import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { DataPercentageComponent } from './data-percentage.component';

@NgModule({
  declarations: [DataPercentageComponent],
  exports: [DataPercentageComponent],
  imports: [CommonModule, SharedModule],
})
export class DataPercentageModule {}
